import Big from 'big.js';
import { useGetValidatorsAuctionData } from '../../../hooks/event-store-hooks';
import { getValidatorWithInfo } from '../../../hooks/get-validator-data';
import { PaginationProps, useClientPagination } from '../../../components';
import { useGetLastBlockInfo } from '../../../hooks';
import { ValidatorWithInfo } from '@block-explorer/entities';
import React, { useEffect } from 'react';

type RandomReshuffledValidators = {
  data: ValidatorWithInfo[] | null;
  loading: boolean;
  error: string | null;
  paginationProps: PaginationProps;
};

export const useGetRandomReshuffledValidators =
  (): RandomReshuffledValidators => {
    const { data: lastBlock } = useGetLastBlockInfo();
    const auctionEraId = lastBlock && lastBlock?.era_id + 2;

    const {
      data: bids,
      loading: bidsLoading,
      error: bidsError,
    } = useGetValidatorsAuctionData(
      auctionEraId
        ? {
            era_id: auctionEraId,
            includes: 'account_info,cspr_name',
            page_size: 99,
            page: 1,
            is_active: 'true',
          }
        : null
    );

    const randomValidatorsMemo = React.useMemo(
      () =>
        getValidatorWithInfo({
          validators: bids || [],
        })
          .filter((validator) => {
            const isValidatorBelowNetworkShareThreshold = Big(
              validator.totalNetworkStakePercentage || '0'
            ).lt(config.validator_network_share_threshold || '0');

            return (
              validator.isVerifiedValidator &&
              isValidatorBelowNetworkShareThreshold
            );
          })
          .sort(() => Math.random() - 0.5),
      [bids]
    );

    const {
      data: validators,
      paginationProps,
      resetState,
    } = useClientPagination({
      paginationStateKey: 'homeValidators',
      arr: randomValidatorsMemo,
      requestParams: {
        defaultPageSize: 1,
      },
    });

    useEffect(() => {
      resetState?.();
    }, []);

    return {
      data: validators,
      loading: bidsLoading,
      error: bidsError,
      paginationProps: paginationProps,
    };
  };
